export default function delay(ms, val = undefined) {
  return new Promise(resolve => {
    window.setTimeout(() => resolve(val), ms)
  })
}
// # sourceMappingURL=delay.js.map
